import React, { useCallback, useEffect, useMemo } from 'react';
import { useIntl } from 'umi';
import { Button, Card } from 'tea-component';
// import { useLocation } from "umi";
import FilterBase from '@/pages/dashboard/components/NewFilter/FilterBase';
// import { isEmpty } from 'lodash-es';
import { getDefaultValue } from './utils';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import { IFilterProps, IFilterValueType, IInputItemType } from './_type';

import './index.scss';
import '@/pages/dashboard/components/Filter/index.scss';
import useSaveInput from '../FilterSave/useSaveInput';
import FilterSave from '../FilterSave';
import { getSaveValue } from '../FilterSave/util';

// 筛选器组件每进入一个页面，重新初始化一次，避免冲突
const Filter = (props: IFilterProps) => {
  const {
    // 筛选器外部loading,筛选器会在外部loading结束后执行初始化 init
    loading,
    onInit,
    value,
    inputList,
    onConfirm: propsOnConfirm,
    onReset: propsOnReset,
    onChange: propsOnChange,
    error,
    loadingHeight = 92,
    children, // 子组件
    // 自定义组件
    extraRenderContent,
    isHaveFilterSave = false,
    isHaveCollapse = false,
    ...restProps
  } = props;
  const { formatMessage } = useIntl();
  // 筛选器保存配置
  const {
    formValue,
    setFormValue,
    selectorSchemeList,
    defaultSelectedItem,
    filterSchemeChange,
    addFilterSchemeList,
    editFilterSchemeList,
    deleteFilterSchemeList,
    selectedValue,
    setSelectedValue,
    filterModalInfo,
    setFilterModalInfo,
  } = useSaveInput(props);
  const [showMore, setShowMore] = React.useState(true);

  // 如果是外部数据源，则取数据源中的最新时间
  // const location = useLocation();

  // 筛选器默认值
  const defaultValue = useMemo(() => {
    const obj: IFilterValueType = {};
    inputList?.forEach((item: IInputItemType) => {
      obj[item.key] = item?.default;
    });
    return obj;
  }, [inputList]);

  // 筛选器初始化，触发init
  useEffect(() => {
    if (!loading && onInit) {
      let value: any = {};
      value = isHaveFilterSave && defaultSelectedItem?.value ? getSaveValue(defaultSelectedItem, inputList) : getDefaultValue(inputList, defaultValue);
      onInit({ ...value });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  // confirm 事件
  const onConfirm = useCallback((value: any): void => {
    propsOnConfirm?.(value);
    // 筛选器方案选中时，confirm变更方案选中状态逻辑
    if (isHaveFilterSave && selectedValue?.filter_name) {
      const isSameValue = JSON.stringify(getSaveValue({ dateType: "dateSelect", value }, inputList))
        === JSON.stringify(getSaveValue(selectedValue, inputList));
      // confirm跟方案不一致，则清空方案选中状态
      if (!isSameValue) {
        setSelectedValue({});
      }
    }
  }, [inputList, isHaveFilterSave, propsOnConfirm, selectedValue, setSelectedValue]);

  // reset 事件
  const onReset = useCallback((value: any): void => {
    propsOnReset?.(value);
    setFormValue(defaultValue);
  }, [defaultValue, propsOnReset, setFormValue]);
  // onChange 事件
  const onChange = (key: any, val: any): void => {
    propsOnChange?.(key, val);
    // 同步更新筛选器保存的值
    if (isHaveFilterSave && formValue[key] !== val) {
      const newFormValue = getSaveValue({ dateType: "dateSelect", value: { ...formValue, [key]: val } }, inputList);
      setFormValue(newFormValue);
    }
  };

  return <>
    <div className="dbh-studio-filter">
      <Card>
        <Card.Body>
          <Abnormal
            isLoading={false}
            isError={error}
            componentLoading={loading}
            style={{ height: loadingHeight }}
            advanceRender={false}
            component={(
              <>
                <FilterBase
                  className={`dbh-studio-filter-content-wrap ${isHaveCollapse && showMore ? 'dbh-studio-filter-content-min' : ''}`}
                  showBubble={false}
                  {...restProps}
                  filterSaveConfig={{
                    isHaveFilterSave,
                    selectorSchemeList,
                    setSelectedValue,
                    setFilterModalInfo,
                  }}
                  value={formValue}
                  defaultValue={defaultValue}
                  inputList={inputList}
                  onConfirm={onConfirm}
                  onReset={onReset}
                  onChange={onChange}
                  inputSlot={
                    <>
                      {isHaveFilterSave && <FilterSave
                        addFilterSchemeList={addFilterSchemeList}
                        editFilterSchemeList={editFilterSchemeList}
                        deleteFilterSchemeList={deleteFilterSchemeList}
                        selectorSchemeList={selectorSchemeList}
                        filterModalInfo={filterModalInfo}
                        setFilterModalInfo={setFilterModalInfo}
                        selectedValue={selectedValue}
                        setSelectedValue={setSelectedValue}
                        inputList={inputList}
                        filterSchemeChange={filterSchemeChange}
                        formValue={formValue}
                        {...restProps}
                      />}
                    </>
                  }
                  tailSlot={
                    isHaveCollapse && <Button
                      type="link"
                      className='dbh-studio-filter-collapse-btn'
                      onClick={() => {
                        setShowMore(!showMore);
                      }}
                    >
                      {formatMessage({ id: showMore ? 'More Filter' : 'Collapse Filter', })}
                    </Button>
                  }
                  extraSlot={
                    <>
                      {
                        extraRenderContent && React.Children.map(extraRenderContent, child => {
                          if (React.isValidElement(child)) {
                            return React.cloneElement(child, {});
                          }
                          // todo 是否返回一个默认元素
                          return null;
                        })}
                    </>
                  }
                />
              </>
            )}
          />
        </Card.Body>
      </Card>
    </div>
    {
      children
    }
  </>;
};

export default Filter;
